<template>
    <div
      class="galleriesVideo"
    >
      <div class="row space-bottom">
        <div class="col-md-6">
          <h3>{{ parseTextintoTitle(type) }}</h3>
        </div>
  
        <div class="col-md-6">
          <button
            class="btn btn-info pull-right"
            @click="update"
            v-if="!inline"
            :disabled="isLoading || isDisabled"
            tabindex="0"
          >
            Set Video
          </button>
        </div>
      </div>
  
      <transition name="slideDown">
        <div class="row space-bottom" v-show="showDropzones">
          <div class="col-md-12">
            <div class="loading-process" v-if="isLoading">
              <p class="text-center"><circle2></circle2></p>
              <div>
                Please Wait Video Upload Process...
              </div>
            </div>
            <div class="loading-process success" v-if="isComplete">
                Upload Success
            </div>
            <dropzone
              id="videoUpload"
              ref="videoUpload"
              :options="configs.dropzones"
              @vdropzone-file-added="fileAddedEvent"
              @vdropzone-sending="completeEvent"
            >
            </dropzone>
          </div>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  import Blazy from 'blazy';
  import Dropzone from 'vue2-dropzone';
  import { Circle2 } from 'vue-loading-spinner';
  import Common from '@/mixins/Common';
  import bus from '@/utils/bus';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  
  let belazy;
  let lazyLoadInterval;
  
  export default {
    name: 'VideoUpload',
  
    mixins: [Common],
  
    data() {
      return {
        videos: [],
        checked: [],
        limit: 60,
        isAll: false,
        meta: null,

        presignedData: {},
        showDropzones: true,
        urlConfigs: '',
        isLoading: false,
        isComplete: false,
        isDisabled: true,
        configs: {
          dropzones: {
            url: '#',
            method: 'put',
            addRemoveLinks: true,
            autoProcessQueue: false,
            timeout: null,
            uploadMultiple: false,
            maxFileSize: 1,
            maxFiles: 1,
            acceptedFiles: 'video/*',
            headers: {
                Accept: 'multipart/form-data',
                'Content-Type': 'multipart/form-data',
            },
          },
        },
      };
    },
  
    props: {
      selected: {
        required: false,
        default: () => [],
      },
  
      type: {
        type: String,
        required: true,
      },
  
      isReview: {
        type: Boolean,
        required: false,
        default: false,
      },
  
      isMultiple: {
        type: Boolean,
        required: false,
        default: false,
      },
  
      inline: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  
    computed: {
      limited() {
        if (this.videos.length > 0) {
          return this.videos.slice(0, this.limit);
        }
        return this.videos;
      },
    },
  
    components: {
      Dropzone,
      Circle2,
    },
  
    watch: {
      limited() {
        this.$nextTick(() => {
          this.revalidateLazyload();
        });
      },
    },
  
    methods: {
      fileAddedEvent(file) {
        const fileType = file.type.split('/');
        const type = fileType[1];
        const data = {
            path: 'activity/review/',
            file_type: type === 'quicktime' ? 'mov' : type,
        };
        if (file.size > 1e+8) {
            this.$swal('Max Size Reached', 'Maximum video file size is 100mb', 'warning');
        } else {
            this.axios.post('galleries/presigned-url', JSON.stringify(data))
            .then((response) => {
                this.presignedData = response.data.data;
                // this.$refs.videoUpload.options.url = response.data.data.presigned_url;
                // this.$refs.videoUpload.dropzone.options.url = response.data.data.presigned_url;
                this.urlConfigs = response.data.data.presigned_url;
                this.isLoading = true;
                this.completeEvent(file);
                // this.$refs.videoUpload.processQueue();
            });
        }
      },
      completeEvent(file) {
        const axios = this.axios.create();
        /* eslint-disable */
        delete axios.defaults.headers.common['Authorization'];
        const config = {
            method: 'put',
            url: this.urlConfigs,
            data: file,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
            },
        };

        axios(config)
        .then((response) => {
            console.log('Status Code : ', response.status);
            this.isLoading = false;
            this.isComplete = true;
            setTimeout(() => {
              this.isComplete = false;
              this.isDisabled = false;
            }, 2000);
            this.axios.defaults.headers.common.Authorization = `Bearer ${this.$store.state.token}`;

        })
        .catch((error) => {
            this.isDisabled = true;
            this.axios.defaults.headers.common.Authorization = `Bearer ${this.$store.state.token}`;
            console.log(error);
        });
      },
      parseVideo(url, size) {
        if (!url) return '';
        const videoUrl = (url.includes('https://')) ? url : `https://${url}`;
        const videoSize = size || '_thumb';
        return videoUrl.substring(0, url.lastIndexOf('.')) + videoSize + videoUrl.substring(url.lastIndexOf('.'));
      },
  
      update() {
        this.$emit('update-video', {
          target: this.type,
          video: this.presignedData.url,
        });
        this.$store.commit('SET_MODAL');
        bus.$emit('close-modal');
      },
  
      lazyLoad() {
        // eslint-disable-next-line no-new, no-unused-vars
        belazy = new Blazy({
          selector: '.thumbnail',
        });
  
        lazyLoadInterval = setInterval(() => {
          this.revalidateLazyload();
        }, 2 * 1000);
      },
  
      revalidateLazyload() {
        if (typeof belazy !== 'undefined') {
          belazy.revalidate();
        }
      },
    },
  
    created() {
      if (this.selected) {
        this.checked = this.selected;
      }
  
    //   this.fetch();
    },
  
    mounted() {
      this.lazyLoad();
    },
  
    beforeDestroy() {
      clearInterval(lazyLoadInterval);
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .galleriesVideo {
    max-height: 100%;
    overflow: hidden;
    overflow-y: auto;
  
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #f1f1f1;
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }
  
    &::-webkit-scrollbar-thumb:hover {
      background-color: #666;
    }
  
    h3 {
      margin: 0;
    }
  
    .space-bottom {
      margin-bottom: 2rem;
    }
  }
  .loading-process {
    display: flex;
    position: absolute;
    background: lightgrey;
    width: 100%;
    align-items: center;
    height: 100%;
    justify-content: center;
    z-index: 9999;
    color: black;
    font-size: 20px;
    font-weight: 600;
    opacity: 0.7;
    &.success {
      opacity: 0.5;
      background: #28a745;
      color: white;
    }
  }
  #thumbnails {
    overflow-y: scroll;
    max-height: 400px;
    // padding-bottom: 200px;
  }
  </style>
  <style lang="css">
  #videoUpload .dz-preview .dz-progress {
    display: none;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/modules/common/VideoUpload.vue